var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisualimage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.21094 29.1681V14.9889H31.8976V29.1681C31.8976 30.7278 30.6215 32.0039 29.0618 32.0039H12.0468C10.4871 32.0039 9.21094 30.7278 9.21094 29.1681Z",
    fill: "#E9EEF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8976 12.153V16.4067H9.21094V12.153C9.21094 10.5933 10.4871 9.31714 12.0468 9.31714H29.0618C30.6215 9.31714 31.8976 10.5933 31.8976 12.153Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9347 14.2799C28.1094 14.2799 29.0616 13.3276 29.0616 12.153C29.0616 10.9784 28.1094 10.0261 26.9347 10.0261C25.7601 10.0261 24.8079 10.9784 24.8079 12.153C24.8079 13.3276 25.7601 14.2799 26.9347 14.2799Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8825 14.2799C16.0571 14.2799 17.0094 13.3276 17.0094 12.153C17.0094 10.9784 16.0571 10.0261 14.8825 10.0261C13.7078 10.0261 12.7556 10.9784 12.7556 12.153C12.7556 13.3276 13.7078 14.2799 14.8825 14.2799Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9348 7.89929C26.155 7.89929 25.5169 8.53735 25.5169 9.31721V12.153C25.5169 12.9329 26.155 13.571 26.9348 13.571C27.7147 13.571 28.3527 12.9329 28.3527 12.153V9.31721C28.3527 8.53735 27.7147 7.89929 26.9348 7.89929ZM14.8825 7.89929C14.1027 7.89929 13.4646 8.53735 13.4646 9.31721V12.153C13.4646 12.9329 14.1027 13.571 14.8825 13.571C15.6624 13.571 16.3004 12.9329 16.3004 12.153V9.31721C16.3004 8.53735 15.6624 7.89929 14.8825 7.89929Z",
    fill: "#172C37"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3901 24.9143H26.2259V27.7501H23.3901V24.9143ZM19.1363 24.9143H21.9722V27.7501H19.1363V24.9143ZM14.8826 24.9143H17.7184V27.7501H14.8826V24.9143ZM23.3901 20.6605H26.2259V23.4964H23.3901V20.6605ZM19.1363 20.6605H21.9722V23.4964H19.1363V20.6605ZM14.8826 20.6605H17.7184V23.4964H14.8826V20.6605Z",
    fill: "#172C37"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0468 19.9515C16.7454 19.9515 20.5543 16.1426 20.5543 11.444C20.5543 6.74546 16.7454 2.93652 12.0468 2.93652C7.34824 2.93652 3.53931 6.74546 3.53931 11.444C3.53931 16.1426 7.34824 19.9515 12.0468 19.9515Z",
    fill: "#FFF9F9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0466 17.8247C15.5706 17.8247 18.4273 14.968 18.4273 11.4441C18.4273 7.92018 15.5706 5.06348 12.0466 5.06348C8.52272 5.06348 5.66602 7.92018 5.66602 11.4441C5.66602 14.968 8.52272 17.8247 12.0466 17.8247Z",
    fill: "#172C37"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3376 6.48132H12.7556V11.444H11.3376V6.48132Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2498 13.6419L14.2976 14.5947L11.5908 11.8879L12.5437 10.9358L15.2498 13.6419Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0466 12.5075C12.6339 12.5075 13.11 12.0314 13.11 11.4441C13.11 10.8567 12.6339 10.3806 12.0466 10.3806C11.4593 10.3806 10.9832 10.8567 10.9832 11.4441C10.9832 12.0314 11.4593 12.5075 12.0466 12.5075Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualimage1);
export default __webpack_public_path__ + "static/media/visualimage1.32a4f742214cd7af27798cceaff4c54f.svg";
export { ForwardRef as ReactComponent };